export default __webpack_public_path__ + "static/media/new-msg-landing.a873cc93.svg";